import { useCompanyData } from "../../context/MasterContextProvider";
import SettingsForm from "./SettingsForm";

const SettingsPage = () => {
  const { company } = useCompanyData();

  return company && <SettingsForm company={company} />;
};

export default SettingsPage;
